import { render, staticRenderFns } from "./View2.vue?vue&type=template&id=db4f9488"
import script from "./View2.vue?vue&type=script&lang=js"
export * from "./View2.vue?vue&type=script&lang=js"
import style0 from "./View2.vue?vue&type=style&index=0&id=db4f9488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports